import { ReactNode } from 'react'
import { ModalKind, Position, setModal, setShowModal } from '.'
import BigGif, {
    type ImageData,
} from '../../components/presentation/ChatImages/Gifs/BigGif'
import i18n from '../../utilities/i18n'

type ConfirmationProps = {
    title?: string
    message?: ReactNode
    onOk?: (e?) => any
    onCancel?: (e?) => any
    cancel?: boolean
    ok?: boolean
}

export const showConfirmation = (show: boolean, immediate = false) =>
    setShowModal(ModalKind.Confirmation, show, immediate)

// this is primarily for ChatActionsBar at the moment
// - we should prefer to create specific functions
export const openConfirmation = ({
    title = null,
    message,
    onOk,
    onCancel,
    cancel = false,
    ok = true,
}: ConfirmationProps) => {
    setModal(
        ModalKind.Confirmation,
        'CONFIRMATION',
        {
            title,
            message,
            onOk,
            onCancel,
            cancel,
            ok,
        },
        true,
    )
}

export const openDeleteAllConfirmation = (onOk: (e?) => any) => {
    setModal(
        ModalKind.Confirmation,
        'CONFIRMATION',
        {
            title: 'Clear Message List',
            message:
                'Are you sure that you want the current list of messages cleared?',
            onOk,
            cancel: true,
        },
        true,
    )
}

export const openGifInsertionConfirmation = (
    onOk: (e?) => any,
    stagedImage: ImageData,
) => {
    setModal(
        ModalKind.Confirmation,
        'CONFIRMATION',
        {
            title: i18n.t('chatImages.insertThisImage'),
            message: <BigGif imageData={stagedImage} />,
            onOk,
            okText: 'Yes',
            cancel: true,
        },
        true,
    )
}

export const openHideModelConfirmation = () => {
    setModal(
        ModalKind.Confirmation,
        'CONFIRMATION',
        {
            title: i18n.t('menu.modelHiddenTitle'),
            message: i18n.t('menu.modelHiddenMessage'),
            ok: true,
        },
        true,
    )
}

export const openStopUserBroadcastingConfirmation = (onOk: () => void) => {
    setModal(
        ModalKind.Confirmation,
        'CONFIRMATION',
        {
            message: i18n.t('userBroadcast.areYouSure'),
            onOk,
            okText: 'Yes',
            cancel: true,
        },
        true,
    )
}

export const openQuickMenu = (id, position: Position, elevated = false) => {
    setModal(
        ModalKind.QuickMenu,
        'QUICK_MENU',
        {
            id,
            position,
            elevated,
        },
        true,
    )
}

export const closeQuickMenu = (immediate = false) => {
    // safeTransition(() => {
    setShowModal(ModalKind.QuickMenu, false, immediate)
    // })
    // setShowModal(ModalKind.Confirmation, false, immediate)
}
